import { render, staticRenderFns } from "./SettingsIntercom.vue?vue&type=template&id=fca268a6&scoped=true&lang=pug&"
import script from "./SettingsIntercom.vue?vue&type=script&lang=js&"
export * from "./SettingsIntercom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca268a6",
  null
  
)

export default component.exports